import {Image as ImageObject} from "../../models/product";
import {Component, h} from "preact";
import {imageService} from "../../services/image-service";
import styles from './style.module.scss';
import {connect} from "redux-zero/preact";

export type ImageDisplayType = 'preview' | 'thumbnail'
export type ImageResolution = 'low' | 'mid' | 'high' | 'higher' | 'full-hd' | 'original'

interface Props {
  image: ImageObject
  alt: string;
  title: string;
  resolution?: ImageResolution;
  displayType?: ImageDisplayType;
  scrollContainer?: string;
  onClickCallback?: (image?: ImageObject) => void
}

interface State {
  src: string;
  loading: boolean;
  loadingIndicator: boolean;
  inView: boolean;
}

class ProductImage extends Component<Props, State> {

  constructor() {
    super();
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleImageError = this.handleImageError.bind(this);
    this.handleViewPortCheck = this.handleViewPortCheck.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    const url = imageService.getUrl(this.props.image, this.props.resolution, this.props.displayType);
    this.setState({src: url, loading: true, inView: false});

    this.addEventListener(this.props.scrollContainer, 'scroll', this.handleViewPortCheck);
    this.addEventListener('#detail-mobile-scroll-container', 'scroll', this.handleViewPortCheck);
    document.addEventListener('scroll', this.handleViewPortCheck);

    setTimeout(() => {
      this.setState({loadingIndicator: true})
    }, 1000)

    this.handleViewPortCheck();
  }

  componentWillUnmount(): void {
    this.removeEventListener(this.props.scrollContainer, 'scroll', this.handleViewPortCheck);
    this.removeEventListener('#detail-mobile-scroll-container', 'scroll', this.handleViewPortCheck);
    document.removeEventListener('scroll', this.handleViewPortCheck);
  }

  componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
    if (nextProps.image && nextProps.image.key != this.props.image?.key) {
      const url = imageService.getUrl(nextProps.image, nextProps.resolution, nextProps.displayType);
      this.setState({src: url, loading: true, inView: false});

      this.addEventListener(this.props.scrollContainer, 'scroll', this.handleViewPortCheck);
      this.addEventListener('#detail-mobile-scroll-container', 'scroll', this.handleViewPortCheck);
      document.addEventListener('scroll', this.handleViewPortCheck);
      this.handleViewPortCheck();
    }
  }

  private getBase(): HTMLElement {
    return this.base as HTMLElement;
  }

  private addEventListener(id: string, type: string, listener: EventListenerOrEventListenerObject) {
    if (id) {
      const element: HTMLElement = document.querySelector(id);
      if (element) {
        element.addEventListener(type, listener);
      }
    }
  }

  private removeEventListener(id: string, type: string, listener: EventListenerOrEventListenerObject) {
    if (id) {
      const element: HTMLElement = document.querySelector(id);
      if (element) {
        element.removeEventListener(type, listener);
      }
    }
  }

  private handleImageLoaded() {
    this.setState({loading: false});
    this.removeEventListener(this.props.scrollContainer, 'scroll', this.handleViewPortCheck);
    this.removeEventListener('#detail-mobile-scroll-container', 'scroll', this.handleViewPortCheck);
    document.removeEventListener('scroll', this.handleViewPortCheck);
  }

  private handleImageError() {
    this.setState({loading: false});
  }

  private isElementInViewport(el: HTMLElement): boolean {
    if (el) {
      const rect = el.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      const marginHeight = viewportHeight * 0.5;
      const marginWidth = viewportWidth * 0.25;

      return (
          rect.top >= -marginHeight &&
          rect.left >= -marginWidth &&
          rect.bottom <= viewportHeight + marginHeight &&
          rect.right <= viewportWidth + marginWidth
      );
    }
    return false;
  }

  private handleViewPortCheck() {
    if (this.isElementInViewport(this.getBase())) {
      this.setState({inView: true});
    }
  }

  private handleOnClick() {
    if (this.props && this.props.onClickCallback) {
      this.props.onClickCallback(this.props.image);
    }
  }


  render(props: Readonly<Props>, state: Readonly<State>) {
    return (
      <div onClick={this.handleOnClick}
        class={`${styles['image-wrapper']} ${props.image.type === 'CUTOUT' ? styles['cutout'] : ''} ${state.loading ? styles['loading'] : ''} ${state.loadingIndicator ? styles['loadingIndicator'] : ''}`}>
        {props.image.type !== 'OUTFIT_VIDEO' ? <img src={state.inView ? state.src : null}
                                                    onLoad={this.handleImageLoaded}
                                                    onError={state.inView ? this.handleImageError : undefined}
                                                    alt={props.alt}
                                                    title={props.title}/> : null}

        {props.image.type === 'OUTFIT_VIDEO' ? <video src={state.inView ? state.src : null}
                                                      onPlay={this.handleImageLoaded}
                                                      onError={state.inView ? this.handleImageError : undefined}
                                                      muted={true}
                                                      loop={true}
                                                      autoPlay={true}
                                                      playsInline={true}/> : null}
      </div>
    )
  }
}

export default connect(null, null)(ProductImage)
